import { defineStore } from 'pinia'
import { dictService } from '@jms/api'

/** DictValueListVo */
interface DictValueListVo {
  dictCode?: string
  dictKey?: string
  dictValue?: string
  dictValueExtra1?: string
  dictValueExtra2?: string
  dictValueExtra3?: string
  dictValueExtra4?: string
  /** @format int64 */
  id?: number
  remark?: string
}
export const useDictStore = defineStore('dict', {
  state: () => ({
    /**银行字典 */
    CASH_BANK: [] as DictValueListVo[]
  }),
  actions: {
    /**
     * 获取数据字典
     * @param dictCode 字典code
     * @returns promise
     */
    getDictList(dictCode: string) {
      return new Promise((resolve, reject) => {
        if (dictCode === 'CASH_BANK' && this.CASH_BANK.length) return resolve(this.CASH_BANK)
        dictService
          .getList({ dictCode })
          .then((res) => {
            if (res.code === 1) {
              switch (dictCode) {
                case 'CASH_BANK':
                  this.CASH_BANK = res.data
                  break
                default:
                  break
              }
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    }
  },
  persist: {
    storage: localStorage
  }
})
